import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="footer-maindiv">
    <div className="footer-grid">
   <div className="footer-brand">

          <div className="foot-logo">
           <img src="/vedastra_logo_bg.webp" alt="logo"  loading="lazy"
            className="cover-img"/>
          </div>

          <h3 className="footer-quote">
            Innovate. Build. Scale.
          </h3>

          <div className="contact-info">
            <p>
              <FaPhoneAlt className="f-icon" />+91 76683 84694
            </p>

            <p>
              <FaEnvelope className="f-icon"  />info@vedastratechnologies.com 
            </p>
          </div>

        </div>
      <div className="footer-container">

        <div className="footer-links">

          <div>
            <h4>Our Services</h4>

             <Link to="/solutions/digital-strategy">
    Digital Strategy & Business Consulting
  </Link>
             <Link to="/solutions/website-development">
    Website Design & Development
  </Link>

  <Link to="/solutions/branding-marketing">
    Branding & Digital Marketing
  </Link>

  <Link to="/solutions/ai-automation">
    AI Automation & Solutions
  </Link>

          </div>


        </div>
 <div className="footer-links">
           <div>

            <h4>Company</h4>

            <Link to="/about-us">About us</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/resources">Resources</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>

          </div>
</div>
      </div>
    </div>
     <div className="footer-bottom">
        Copyright © 2026 Vedastra Technologies. All Rights Reserved
      </div>
    </div>
  );
};

export default Footer;